import { ArrowForward } from '@mui/icons-material';
import { Typography } from '@mui/material';
import type { GridColDef } from '@mui/x-data-grid';
import { Chip, type ChipProps } from '@side/pantry';
import { GlossaryTooltip } from '../../components/GlossaryTooltip';

export function getComparisonViewColumns({
  currentPeriodLabel,
  pastPeriodLabel,
}: {
  currentPeriodLabel: string;
  pastPeriodLabel: string;
}): GridColDef<{
  label: string;
  past: number;
  current: number;
  percentChange: number | 'New';
}>[] {
  return [
    {
      field: 'label',
      renderHeader: () => null,
      flex: 2,
      minWidth: 195,
      renderCell: ({ row: { label } }) => {
        return (
          <GlossaryTooltip label={label}>
            <Typography
              variant="subtitle2"
              component="span"
              sx={{ color: 'text.primary' }}
            >
              {label}
            </Typography>
          </GlossaryTooltip>
        );
      },
    },
    {
      field: 'past',
      headerName: 'Past',
      renderHeader: () => (
        <GlossaryTooltip caption={`Data from: ${pastPeriodLabel}`}>
          <Typography variant="body3">Past</Typography>
        </GlossaryTooltip>
      ),
      flex: 1,
      minWidth: 100,
    },
    {
      field: 'current',
      headerName: 'Current',
      renderHeader: () => (
        <GlossaryTooltip caption={`Data from: ${currentPeriodLabel}`}>
          <Typography variant="body3">Current</Typography>
        </GlossaryTooltip>
      ),
      flex: 1,
      minWidth: 100,
      renderCell: ({ row: { current } }) => {
        return (
          <Typography
            variant="body2"
            component="span"
            sx={{ color: 'text.primary' }}
          >
            {current}
          </Typography>
        );
      },
    },
    {
      field: 'percentChange',
      flex: 1,
      minWidth: 100,
      renderHeader: () => null,
      renderCell: ({ row: { percentChange } }) => {
        let color: ChipProps['color'] = 'default';
        let iconRotation = 0;
        if (typeof percentChange === 'string' || percentChange > 0) {
          color = 'success';
          iconRotation = -90;
        } else if (percentChange < 0) {
          color = 'error';
          iconRotation = 90;
        }
        return (
          <Chip
            size="small"
            icon={
              <ArrowForward
                sx={{ transform: `rotate(${iconRotation}deg)`, fontSize: 14 }}
              />
            }
            label={
              typeof percentChange === 'string'
                ? percentChange
                : `${percentChange}%`
            }
            color={color}
            variant="outlined"
          />
        );
      },
    },
  ];
}

export const LOADING_ROWS = [
  {
    id: 'sales-volume',
    label: 'Sales Volume',
    past: null,
    current: null,
    percentChange: null,
  },
  {
    id: 'adjusted-gci',
    label: 'Post-Referral GCI',
    past: null,
    current: null,
    percentChange: null,
  },
  {
    id: 'total-transactions',
    label: 'Total Transactions',
    past: null,
    current: null,
    percentChange: null,
  },
  {
    id: 'average-sale-value',
    label: 'Average Sale Value',
    past: null,
    current: null,
    percentChange: null,
  },
  {
    id: 'average-commission',
    label: 'Average Commission %',
    past: null,
    current: null,
    percentChange: null,
  },
];
